// extracted by css-extract-rspack-plugin
export default {"container":"xFNAU","altDomain":"_Oy9N","description":"iLiBm","qrCode":"i_nA5","title":"arkKe"};